import React, { useState, useEffect, useContext } from "react";
import { Table, Modal } from "antd";
import Api from "../../services/ServiceApi";
import { StopTimeDetailModal } from "../uih/full_detail_job/stop_time/Stop_time_card";
import { FormatDateTime } from "../utility/format";
import ApproveProcessModal from "../approve_process/approve_process_modal";
import ApproveProcessLogModal from "../approve_process/approve_process_log_modal";

import DynamicLabelGroup from "../dynamic_label/dynamic_label_group";

import Skeleton from "react-loading-skeleton";
// import Renderbtn from "../../pages/uih/wf_controllers/BtnController/renderButton";

import { NumberWithCommas } from "../utility/format";
import { authUserContext } from "../../contexts";

// sendComponent
// import ApproveProcessForm from "../approve_process/approve_process_form";
// import ApproveProcessLog from "../approve_process/approve_process_log";

export default function TableApproveInService({
  title,
  companyId,
  operatorId,
  projectId,
  masterLang,
  factUpdate,
  enableController = true,
  searchCriteria = null,
}) {
  const [itemsList, setitemsList] = useState([]);
  const [callApiFinish, setcallApiFinish] = useState(false);
  const [sendData, setsendData] = useState(null);
  const [showStoptimeDetail, setshowStoptimeDetail] = useState(false);
  const [showApproveProcessLog, setshowApproveProcessLog] = useState(false);
  const authUser = useContext(authUserContext);
  const { REACT_APP_DELAY_REQUEST_API_MINUTE } = process.env;
  const delayRequest = (REACT_APP_DELAY_REQUEST_API_MINUTE || 1) * 60 * 1000;
  const getProcessGroup = "IN_SERVICE";
  const locale = authUser.locale;
  const [showApproveCondition, setshowApproveCondition] = useState(false);
  const getStopTimeRequest = () => {
    Api.post("Approve/get_inservice_approve_process", {
      company_id: companyId,
      operator_id: operatorId,
      project_id: projectId,
      process_group: getProcessGroup,
      operation_name:
        searchCriteria?.operationName[0] !== null
          ? searchCriteria?.operationName
          : null,
    }).then((res) => {
      const { result, data } = res.data;
      if (result.code === "P") {
        setitemsList(data.approveProcess);
        setcallApiFinish(true);
      }
    });
  };
  useEffect(() => {
    getStopTimeRequest();
    const setCallinterval = setInterval(() => {
      getStopTimeRequest();
    }, delayRequest);
    return () => {
      clearInterval(setCallinterval);
    };
  }, [callApiFinish, searchCriteria]);

  function setLinktoController(job_id) {
    window.open(
      Api.absoluteUrl(
        `/full_detail_job/${companyId}/${operatorId}/${projectId}/${job_id}`
      )
    );
  }
  const columns = [
    {
      title: null,
      dataIndex: "",
      key: "",
      ellipsis: {
        showTitle: false,
      },
      width: 20,
    },
    /*
    {
      title: null,
      dataIndex: "",
      key: "",
      ellipsis: {
        showTitle: false,
      },
      width: 40,
      render: (item) => (
        <>
          <Tooltip
            title={
              JSON.parse(item.approve_config_desc)[0].approve_config_desc_header?.input.data + ` ` + JSON.parse(item.approve_config_desc)[1].approve_config_desc_detail
                ?.input.data
            }
            title=""
            color={item.backgroundColor}
            key={item.color}
          >
            <span>
              <BadgePill
                bgColor={item.backgroundColor}
                color={item.color}
                text={`${item.status.substring(0, 1)}${
                  item.last_approve_level_seq
                }`}
              ></BadgePill>
            </span>
          </Tooltip>
        </>
      ),
    },
    {
      title: null,
      dataIndex: "",
      key: "",
      ellipsis: {
        showTitle: false,
      },
      width: 45,
      render: (item) => (
        <Tooltip title="ดูรายละเอียดการ Approve In Service Time">
          <span>
            <Renderbtn
              renderBtn={{
                visible: true,
                html_tag: "button",
                type: "FA",
                text: "History",
                font_awasome: "fas fa-history",
                css: "btn btn-sm btn-light",
              }}
              btnMiddleware={(items) => {
                setsendData(items);
                setshowApproveProcessLog(true);
              }}
              index="view_btn_stoptime2"
              item={item}
              disable={false}
            ></Renderbtn>
          </span>
        </Tooltip>
      ),
    },
*/

    {
      title: "SO No.",
      dataIndex: "",
      key: "",
      width: 90,
      render: (items) => (
        <a
          href={null}
          className="c-blue text-underline font-bold"
          onClick={() => setLinktoController(items.job_id)}
        >
          {items.so_id}
        </a>
      ),
    },
    {
      title: <span className="d-flex justify-content-center">Impact</span>,
      dataIndex: "uih_total_impact",
      key: "uih_total_impact",
      ellipsis: {
        showTitle: false,
      },
      width: 70,
      render: (item) => (
        <span className="d-flex justify-content-center">{item}</span>
      ),
    },
    {
      title: <span className="d-flex justify-content-center">Area</span>,
      dataIndex: "area_code",
      key: "area_code",
      ellipsis: {
        showTitle: false,
      },
      width: 60,
      render: (item) => (
        <span className="d-flex justify-content-center">{item}</span>
      ),
    },
    {
      title: <span className="col-openby">Open by</span>,
      dataIndex: "",
      key: "",
      width: 150,
      render: (item) => (
        <span className="col-openby">
          {item.uih_resp_open_by}
          <br />
          {item.uih_resp_operation_name}
        </span>
        // <div className="d-flex justify-content-center">
        //   <div className="c-blue font-bold text-center">{item.uih_resp_open_by}<br />{item.uih_resp_operation_name}</div>
        // </div>
      ),
    },
    {
      title: <span className="col-dtrequest">DT Request</span>,
      dataIndex: "request_date",
      key: "request_date",
      width: 160,
      render: (items) => {
        if (items !== null) {
          return (
            <div className="col-dtrequest">
              <FormatDateTime text={items} format="dmyHm"></FormatDateTime>
            </div>
          );
        } else {
          return <span>ไม่พบข้อมูล DT Request</span>;
        }
      },
    },
    {
      title: <div className="col-waittime">Wait (Min)</div>,
      dataIndex: "wait_time",
      key: "wait_time",
      ellipsis: {
        showTitle: false,
      },
      width: 70,
      render: (item) => (
        <div className="d-flex justify-content-center">
          <span className="font-bold">
            <NumberWithCommas number={item}></NumberWithCommas>
          </span>
        </div>
      ),
    },
  ];

  const rows = itemsList?.map((s) => ({
    so_id: s.so_id,
    area_code: s.area_code,
    status: s.approve_status_name,
    statusid: s.approve_status_id,
    progress_detail: s.progress_type_name,
    reference_id: s.reference_id,
    status_desc: s.job_status_name,
    approve_id: s.approve_id,
    last_approve_level_seq: s.last_approve_level_seq,
    job_no: s.job_no,
    job_id: s.job_id,
    approve_config_desc: s.approve_config_desc,
    process_name: s.process_name,
    approve_status_id: s.approve_status_id,
    data_dynamic: s.data_dynamic,
    backgroundColor: s.approve_status_bgcolor,
    color: s.approve_status_color,
    request_date: s.request_date,
    wait_time: s.wait_time,
    uih_total_impact: s.uih_total_impact,
    uih_resp_open_by: s.uih_resp_open_by,
    uih_resp_operation_name: s.uih_resp_operation_name,
  }));

  const [modalShow, setmodalShow] = useState(false);
  const showModalApproveDes = (item) => {
    setsendData(item.approve_config_desc);
    setshowApproveCondition(true);
  };
  const approveLogModalCallBack = () => {
    setshowApproveProcessLog(false);
  };
  const approveFormModalCallBack = () => {
    setmodalShow(false);
    setcallApiFinish(!callApiFinish);
  };
  return (
    <>
      <h5 className="dashboard-card-title">
        {title} <span>{rows.length}</span>
      </h5>
      <div className=" mb-3 card">
        <div className="card-body dashboard-card">
          {callApiFinish ? (
            <Table
              pagination={false}
              // scroll={rows.length > 0 ? { y: 361, x: 600 } : null}
              scroll={{ y: 361, x: 600 }}
              tableLayout="fixed"
              columns={
                enableController
                  ? columns
                  : columns.filter((col) => col.title !== null)
              }
              dataSource={rows}
              className="dashboard-table"
              rowClassName={(record) =>
                record.wait_time
                  ? record.wait_time > 15
                    ? "bg-danger"
                    : record.wait_time > 10
                    ? "bg-warning"
                    : null
                  : null
              }
            />
          ) : (
            <Skeleton height={320}></Skeleton>
          )}
        </div>
      </div>
      {modalShow ? (
        <ApproveProcessModal
          visible={modalShow}
          callbackFunction={approveFormModalCallBack}
          sendData={sendData ? sendData : null}
        ></ApproveProcessModal>
      ) : null}
      {showStoptimeDetail ? (
        <StopTimeDetailModal
          modalOpen={showStoptimeDetail}
          setmodalOpen={setshowStoptimeDetail}
          language={masterLang}
          factupdate={factUpdate}
          sendData={sendData ? sendData : null}
        ></StopTimeDetailModal>
      ) : null}
      {showApproveProcessLog ? (
        <ApproveProcessLogModal
          visible={showApproveProcessLog}
          callbackFunction={approveLogModalCallBack}
          sendData={sendData ? sendData : null}
        ></ApproveProcessLogModal>
      ) : null}
      {showApproveCondition ? (
        <Modal
          title={<h4>Approve Description</h4>}
          footer={null}
          visible={showApproveCondition}
          wrapClassName={"bbtec-theme"}
          onCancel={() => setshowApproveCondition(false)}
        >
          <DynamicLabelGroup
            data={sendData}
            groupHeader={false}
            language={masterLang}
            factupdate={factUpdate}
            locale={locale}
            wrapClassname={"bbtec-theme"}
          ></DynamicLabelGroup>
        </Modal>
      ) : null}
    </>
  );
}
